import { render, staticRenderFns } from "./DataCheck.vue?vue&type=template&id=a99d5f90&scoped=true&"
import script from "./DataCheck.vue?vue&type=script&lang=js&"
export * from "./DataCheck.vue?vue&type=script&lang=js&"
import style0 from "./DataCheck.vue?vue&type=style&index=0&id=a99d5f90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99d5f90",
  null
  
)

export default component.exports